let guestModeActive = false;

export function setGuestModeActive(active) {
  guestModeActive = Boolean(active);
}

export function getGuestModeActive() {
  return guestModeActive;
}
